import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Loader } from '@googlemaps/js-api-loader';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import css from './Shop.module.scss';
import PinMap from './PinMap';
import { jsx as _jsx } from "react/jsx-runtime";

var loadMap = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(lat, lng) {
    var GOOGLE_API_KEY, mapId, loader, center, google, map;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(lat === null || lng === null)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            GOOGLE_API_KEY = 'AIzaSyAt4sO--DgwjhQNR2fDBXs6kIflD7WuzIY';
            mapId = '3ddd67acaa89b6fb';
            loader = new Loader({
              apiKey: GOOGLE_API_KEY,
              version: 'weekly',
              libraries: ['places']
            });
            center = {
              lat: lat,
              lng: lng
            };
            _context.prev = 6;
            _context.next = 9;
            return loader.load();

          case 9:
            google = _context.sent;
            map = new google.maps.Map(document.getElementById('map'), {
              center: center,
              options: {
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false
              },
              mapId: mapId,
              zoom: 18
            });
            new google.maps.Marker({
              position: center,
              icon: {
                url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(ReactDOMServer.renderToString( /*#__PURE__*/_jsx(PinMap, {})))
              },
              map: map
            });
            console.info('Map initialized');
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](6);
            console.error('Error loading map', _context.t0);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 15]]);
  }));

  return function loadMap(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var ShopMap = function ShopMap(_ref2) {
  var lat = _ref2.lat,
      lng = _ref2.lng;
  useEffect(function () {
    loadMap(lat, lng);
  }, [lat, lng]);
  return /*#__PURE__*/_jsx("div", {
    className: css.map,
    id: "map"
  });
};

ShopMap.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired
};
export default ShopMap;